import { FC } from 'react';
import Flex from 'src/styles/layouts/Flex';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import { StyledSliderDot } from './SliderDots.styles';
import { ISliderDot } from './SliderDots.type';

const SliderDots: FC<ISliderDot> = ({ selectedIndex, onSelectIndex, onMouseEnter, onMouseLeave }) => {
	return (
		<Flex vertical={EFlex.center} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
			{[0, 1, 2].map((v, i) => (
				<StyledSliderDot isSelected={i === selectedIndex} key={'dot-' + v} onClick={() => onSelectIndex(i)} />
			))}
		</Flex>
	);
};

export { SliderDots };
